import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

// NOTE: the base StoreModel owns `@observable currentHostname = 0`, filled only for stores
// that app.js calls setVersion() on — this store is not one of them. mobx installs that
// field as an own instance property, which shadows a subclass getter and silently sends
// `hostname=0`, so the hostname is read from the browser here instead of via `this`.
const browserHostname = () => (typeof window !== 'undefined' ? window.location.hostname : '');

/**
 * Help-center search gaps: which queries members search for and how many articles they hit.
 * Logging is public (works logged out); the list/dismiss/draft calls are admin + media worker only.
 */
class HelpSearchStore extends LocalModel {
    constructor() {
        super('helpSearch', {
            namePlural: 'helpSearches',
            namePluralReal: 'helpsearches',
            sort: '-count',
            limit: 200,
            api: {
                search: {
                    url: '/api/helpsearches/',
                    params: {
                        limit: 200,
                        sort: '-count',
                    },
                },
                load: {
                    url: '/api/helpsearches/',
                    params: {},
                },
                save: {
                    url: '/api/helpsearches/',
                    params: {},
                },
                delete: {
                    url: '/api/helpsearches/',
                    params: {},
                },
            },
        });
    }

    @observable helpSearch = {};

    @observable helpSearches = [];

    // Number of open gaps for the current hostname — drives the badge on the help-center button.
    @observable openCount = 0;

    async logSearch({ search, hits }) {
        return util.fetchApi('/api/helpsearches/', { method: 'POST' }, {
            hostname: browserHostname(),
            search,
            hits,
        });
    }

    @action
    async loadGaps(status = 'open') {
        const response = await util.fetchApi('/api/helpsearches/', { method: 'GET' }, {
            hostname: browserHostname(),
            status,
        });
        const rows = response?.status === 200 && Array.isArray(response.data) ? response.data : [];
        this.updateKeyValue('helpSearches', rows);
        if (status === 'open') {
            this.updateKeyValue('openCount', rows.length);
        }
        return rows;
    }

    async setStatus(id, status) {
        return util.fetchApi(`/api/helpsearches/${id}`, { method: 'PATCH' }, { status });
    }

    async draftArticle(id) {
        return util.fetchApi(`/api/helpsearches/${id}/draft`, { method: 'POST' }, {});
    }
}

const store = new HelpSearchStore();
export default store;
